import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/people/NewDonorsReport.jsx
// — renamed Donor -> Member, endpoint moved to /reports/memberships/new-members
// (MembershipReportController::newMembers()).
const COLUMNS: ReportColumn[] = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'member_since', label: 'Member Since' },
  { key: 'member_type', label: 'Member Type' },
];

export function NewMembersReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="New Members Report"
      description="Members who joined within a date range."
      endpoint="/reports/memberships/new-members"
      columns={COLUMNS}
      filters={['category', 'dateRange']}
      categoryOptions={listOptions(lists, 'member_type')}
    />
  );
}
